import { IWidget } from "@/types/map";
// import { loadModules } from "esri-loader";
import { Vue } from "vue-property-decorator";
import MeasurementDiv from "@/plugin/gis-viewer/widgets/WidgetsManager/pgis/MeasurementPGIS.vue";
import searchPop from "@/plugin/gis-viewer/widgets/WidgetsManager/pgis/searchPopPGIS.vue";
// import { removeData, type } from "jquery";

export default class WidgetsManagerPGIS {
  private view!: any;
  private static intances: Map<string, WidgetsManagerPGIS>;

  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: any) {
    let id = view.getTarget();
    if (!WidgetsManagerPGIS.intances) {
      WidgetsManagerPGIS.intances = new Map();
    }
    let instance = WidgetsManagerPGIS.intances.get(id);
    if (!instance) {
      instance = new WidgetsManagerPGIS(view);
      WidgetsManagerPGIS.intances.set(id, instance);
    }
    return instance;
  }
  public async initWidgets(params: Array<IWidget>) {
    let widgets: Array<IWidget> = params;
    widgets.forEach((widget) => {
      let relativePos: any;
      let position: string = "top-left";
      let toolDiv: any = undefined;
      let vm: any;
      let defaultVisible = widget.visible !== false;
      switch (widget.name) {
        case "zoom":
          toolDiv = document.getElementById("fmapZoomsliderDiv");
          break;
        case "draw":
          break;
        case "measure":
          //测线工具
          vm = new Vue({
            // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
            render: (h) => h(MeasurementDiv, { props: { map: this.view } } as any) // render 生成虚拟dom  {props: props}
          }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
          toolDiv = vm.$el as HTMLElement;
          toolDiv.id = "measure";
          break;
        case "locate":
          //定位工具
          // Add the locate widget to the top left corner of the view
          break;
        case "search":
          //搜索工具
          vm = new Vue({
            // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
            render: (h) => h(searchPop, { props: { map: this.view } } as any) // render 生成虚拟dom  {props: props}
          }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
          toolDiv = vm.$el as HTMLElement;
          toolDiv.id = "search";
          break;
        case "coordinate":
          //坐标工具
          break;
      }
      if (widget.config && widget.config.position) {
        if (typeof widget.config.position == "string") {
          position = widget.config.position;
        } else {
          relativePos = widget.config.position;
        }
      }
      if (toolDiv) {
        toolDiv.style.position = "absolute";
        if (!defaultVisible) {
          toolDiv.style.display = "none";
        }
        this.view.getTargetElement().appendChild(toolDiv);

        if (relativePos) {
          toolDiv.style.left = relativePos.left || "";
          toolDiv.style.right = relativePos.right || "";
          toolDiv.style.top = relativePos.top || "";
          toolDiv.style.bottom = relativePos.bottom || "";
        }
      }
    });
  }
  public async toggleWidget(widgetNames: string[] | string) {
    let widgets: string[] =
      typeof widgetNames === "string" ? [widgetNames] : widgetNames;
    widgets.forEach((widgetName) => {
      let widget: any = document.getElementById(widgetName);
      if (widget) {
        let el: any = widget.container || widget;
        if (el.style.display == "none") {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      }
    });
  }
}
